import { useLocation, useNavigate } from 'react-router-dom';

export interface DirectionsNavigationState {
  returnTo: string;
  returnState: unknown;
  appointmentId?: string;
}

export function useDirectionsNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  return (appointmentId?: string) => navigate('/directions', {
    state: {
      returnTo: `${location.pathname}${location.search}${location.hash}`,
      returnState: location.state,
      appointmentId,
    } satisfies DirectionsNavigationState,
  });
}
